module.exports = __webpack_public_path__ + "static/media/comments-alt.78d65f58.svg";